import axios from 'axios'
import { API_ROOT } from '@/api/config'
import storage from '@/plugins/storage'
import { toFormdata } from '@/constants/global/util'

const defaultConfig = {
  ...storage.get('access_token'),
  locale: storage.get('locale')
}

// user
export const getUser = (config) => axios.get(API_ROOT + 'users/current', { params: { ...defaultConfig, ...config } })
export const postUser = (data, config) => axios.post(API_ROOT + 'users/sign_in', data, { params: { ...defaultConfig, ...config } })
export const deleteUser = (config) => axios.delete(API_ROOT + 'users/sign_out', { params: { ...defaultConfig, ...config } })
// file
export const getUploadFiles = (params, config) => axios.get(API_ROOT + 'upload_files', { params: { ...defaultConfig, ...config, ...params } })
export const postUploadFile = (data, config) => axios.post(API_ROOT + 'upload_files', data, { params: { ...defaultConfig, ...config } })
